module.exports = __webpack_public_path__ + "img/service-content-money@3x.240e22b1.png";